<template>
  <div class="py-5 text-center">
    <div class="container">
      <h1 class="who-is fw-light text-dark animated fadeIn text-poppins">{{ $t('who_is') }} <b>Indiefy</b></h1>
      <div class="row mt-5 columns-who">
        <div class="col-md-4 mb-3 animated fadeInUp">
          <h2 class="text-dark text-poppins">{{ $t('the_problem') }}</h2>
          <p class="px-4 mt-4">
            {{ $t('the_problem_description') }}
          </p>
        </div>
        <div class="col-md-4 mb-3 animated fadeInUp animation-delay-200">
          <h2 class="text-dark text-poppins">{{ $t('what_we_do') }}</h2>
          <p class="px-4 mt-4">
            {{ $t('what_we_do_description') }}<br/><br/>
            {{ $t('what_we_do_description_2') }}
          </p>
        </div>
        <div class="col-md-4 mb-3 animated fadeInUp animation-delay-400">
          <h2 class="text-dark text-poppins">{{ $t('the_company') }}</h2>
          <p class="px-4 mt-4">
            {{ $t('the_company_description') }}<br/><br/>
            {{ $t('the_company_description_2') }}
          </p>
        </div>
      </div>

      <h1 class="who-is fw-light text-dark animated fadeIn animation-delay-500 mt-4 text-poppins">{{ $t('our') }} <b>{{ $t('team') }}</b></h1>
      <div class="row justify-content-center mt-5 text-center">
        <div class="col-team col-md-3 col-sm-6">
          <div class="team-member gil">
            <div class="description pt-2 fw-light">
              <div>Gilberto Avalos</div>
              <div class="strong">CEO</div>
            </div>
          </div>
        </div>
        <!-- <div class="col-team col-md-3 col-sm-6">
          <div class="team-member alex">
            <div class="description p-1 fw-light">
              <div>Alex Hernandez</div>
              <div class="strong">Content Manager</div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="row mt-3 justify-content-center">
        <div class="col-team col-md-3 col-sm-6">
          <div class="team-member julio">
            <div class="description p-1 fw-light">
              <div>Julio Pulido</div>
              <div class="strong">COO</div>
            </div>
          </div>
        </div>
        <div class="col-team col-md-3 col-sm-6">
          <div class="team-member ricardo">
            <div class="description p-1 fw-light">
              <div>Ricardo Avalos</div>
              <div class="strong">Content</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="preload-images">
      <img src="/static/img/landing/team/gil_2.jpg" alt="Gilberto Avalos - Head Twister">
      <img src="/static/img/landing/team/ricardo_2.jpg" alt="Ricardo Avalos">
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingAbout',
  created: function () {
    window.document.title = this.$t('landing_about')
    window.$('meta[property="og:title"]').attr('content', this.$t('landing_about'))
    window.$('meta[name="description"]').attr('content', this.$t('landing_about_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_about_description'))
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true
    }, 100)
  }
}
</script>
<style lang="scss" scoped>
.who-is {
  font-size: 4em;
}

.columns-who {
  font-size: 0.9em;
  color: #8E8E91;
}

.team-member {
  border-radius: 50%;
  display: inline-block;
  position: relative;
  background: #eee;
  width: 150px;
  height: 150px;
  margin-bottom: 25px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.team-member {
  transition: all .1s ease-in;
  transform: scale(1);
  overflow: hidden;

  .description {
    transition: all .1s ease-in;
    bottom: -50px;
    background: rgba(0, 0, 0, 0.5);
    height: 50px;
    position: absolute;
    left: 0;
    width: 100%;
    font-size: 11px;
    color: white;
  }

  &.gil {
    background-image: url('/static/img/landing/team/gil.png');

    &:hover {
      background-image: url('/static/img/landing/team/gil_2.jpg');
    }
  }

  &.eddie {
    background-image: url('/static/img/landing/team/eddie.png');

    .strong {
      font-size: 10px;
    }
  }

  &.alex {
    background-image: url('/static/img/landing/team/alex.png');

    &:hover {
      background-image: url('/static/img/landing/team/alex_2.jpg');
    }

    .strong {
      font-size: 10px;
    }
  }

  &.julio {
    background-image: url('/static/img/landing/team/julio.jpg');

    &:hover {
      background-image: url('/static/img/landing/team/julio.jpg');
    }

    .strong {
      font-size: 10px;
    }
  }

  &.kazacha {
    background-image: url('/static/img/landing/team/kazacha.jpg');

    &:hover {
      background-image: url('/static/img/landing/team/kazacha_2.jpg');
    }
  }

  &.ricardo {
    background-image: url('/static/img/landing/team/ricardo.png');

    &:hover {
      background-image: url('/static/img/landing/team/ricardo_2.jpg');
    }

    .strong {
      font-size: 10px;
    }
  }

  &:hover {
    transform: scale(1.2);

    .description {
      bottom: 0;
    }
  }
}

.preload-images {
  position: fixed;
  top: -100px;
  left: -100px;

  img {
    width: 1px;
    height: 1px;
  }
}

@media screen and (max-width:576px) {
  .col-team {
    flex: 0 0 33%;
    max-width: 33%;
  }

  .team-member {
    width: 100px;
    height: 100px;

    &.alex .description {
      font-size: 9px;
    }

    .description .strong {
      font-size: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingAbout.vue